import type { ReactNode } from 'react';
import { Icon } from './Icon.js';

export function Drawer({
  open,
  onClose,
  title,
  wide,
  children,
  actions,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  wide?: boolean;
  children: ReactNode;
  actions?: ReactNode;
}) {
  if (!open) return null;
  return (
    <>
      <div className="drawer-scrim" onClick={onClose} />
      <aside className={`drawer${wide ? ' wide' : ''}`} role="dialog" aria-label={title}>
        <header className="drawer-h">
          <span className="h-strong upper">{title}</span>
          <div style={{ display: 'flex', gap: 6 }}>
            {actions}
            <button className="btn xs gh" onClick={onClose} aria-label="Close">
              <Icon name="x" size={12} />
            </button>
          </div>
        </header>
        <div className="drawer-body">{children}</div>
      </aside>
    </>
  );
}
